import {Component, ElementRef, Input, OnInit, ViewChild} from '@angular/core';
import {Chart} from "chart.js";
import * as moment from "moment";
import ChartDataLabels from "chartjs-plugin-datalabels";

@Component({
    selector: 'app-app-graph',
    templateUrl: './app-graph.component.html',
    styleUrls: ['./app-graph.component.scss'],
})
export class AppGraphComponent implements OnInit {
    @ViewChild("graph", {'static': true}) graph: ElementRef;

    @Input()
    graphType;
    @Input()
    graphData;
    @Input()
    graphData2;
    @Input()
    graphKeys;
    @Input()
    graphkeyType;

    constructor() {
    }

    ngOnInit(): void {
        let me = this;
        //graphs
        setTimeout(function () {
            console.log('me.graphType:', me.graphType)
            // let lables = ["Red", "Blue", "Yellow", "Green", "Purple", "Orange"]
            // let data = [12, 19, 3, 5, 2, 3]
            // me.setChart(me.graph, lables, data, 'bar', ['#53f554', '#ff35a4', '#126fa1', '#6516f3']);
            me.getGraph(me.graph, me.graphData, me.graphData2, me.graphType ? me.graphType : 'bar')
        }, 1);
    }

    getGraph(barCanvas, graphModels, graphModels2 = null, graphType = 'bar') {
        // graphVarId
        let keys = [];
        let values = [];
        let values2;
        let colors = [];

        if (graphModels2) {
            values2 = [];
        }

        console.log(this.graphKeys);
        console.log(graphModels);

        let labelkey;
        for (let key in graphModels) {
            labelkey = graphModels[key][this.graphKeys[0] + '__name'] ? graphModels[key][this.graphKeys[0] + '__name'] :
                graphModels[key][this.graphKeys[0]];

            if (this.graphkeyType[0] == 'date') {
                // //console.loglabelkey);
                let dt = moment(labelkey);
                // //console.logdt);
                keys.push(dt.format('HH DD/MM'));
            } else {
                keys.push(labelkey);
            }

            values.push(graphModels[key][this.graphKeys[1]]);
            if (graphModels2) values2.push(graphModels2[key][this.graphKeys[1]]);
            // if (resReportData['graph'][2]) {
            //     values2.push(models[key][resReportData['graph'][2]]);
            // }

            // if (models[key][resReportData['graph'][0] + '__color']) {
            //     colors.push(models[key][resReportData['graph'][0] + '__color']);
            // } else {
            //     colors.push(-1);
            // }
        }
        // //console.logkeys);
        // //console.logvalues);
        // let lables = ["קבלנים", "..."];
        // let data = [1,52,13,,43];

        console.log(keys)
        console.log(values)

        let me = this;
        setTimeout(function () {
            me.setChart(barCanvas, keys, values, graphType, values2);
        });
    }

    //lables = ["Red", "Blue", "Yellow", "Green", "Purple", "Orange"]
    //data = [12, 19, 3, 5, 2, 3]
    setChart(barElement, labales, data, type, data2 = null, dcolors = null) {
        // if (this.barChart) {
        //     this.barChart.clear();
        // }

        let colors = [];
        let colorsData = {
            "primary": "rgba(56, 128, 255, 0.2)",
            "danger": "rgba(245, 61, 61, 0.2)",
            "warning": "rgba(255, 206, 0, 0.2)",
            "secondary": "rgba(12, 209, 232, 0.2)",
            "dark": "rgba(34, 34, 34, 0.2)",
            "success": "rgba(16, 220, 96, 0.2)"
        };

        for (let key in colorsData) {
            colors.push(colorsData[key]);
        }

        if (dcolors) {
            for (let key in dcolors) {
                if (dcolors[key] != -1) {
                    colors[key] = colorsData[dcolors[key]];
                }
            }
        }

        let datasets = [];
        if (type == 'radar') {
            for (let i in data) {
                datasets.push({
                    'label': i,
                    'data': data[i]
                })
            }
        } else {
            datasets = [
                {
                    label: "",
                    data: data,
                    backgroundColor: colors,
                    borderColor: colors,
                    borderWidth: 1
                }
            ];
        }

        if (data2) {
            datasets.push({
                label: "",
                data: data2,
                backgroundColor: colors,
                borderColor: colors,
                borderWidth: 1
            })
        }

        // line.
        // bar.
        // radar.
        // doughnut and pie.
        // polar area.
        // bubble.
        // scatter.

        //
        //         type: 'horizontalBar',
        new Chart(barElement.nativeElement, {
            plugins: [ChartDataLabels],
            type: type,
            data: {
                labels: labales,
                datasets: datasets
            },
            options: {
                plugins: {
                    // Change options for ALL labels of THIS CHART
                    datalabels: {
                        color: '#00000',
                        rotation: 30,
                        labels: {
                            title: {
                                font: {
                                    weight: 'bold'
                                }
                            },
                            value: {
                                color: '#00000'
                            }
                        }
                    }
                },
                scales: {
                    yAxes: [
                        {
                            ticks: {
                                beginAtZero: true
                            }
                        }
                    ]
                }
            }
        });
    }
}
